import i18n from 'modules/core/lib/i18n'

export function getEvaluationType(type: string) {
  switch (type) {
    case 'self':
      return {
        title: i18n.t('performance_process.reviews.answer_evaluation.evaluation_type.self.title'),
        description: i18n.t(
          'performance_process.reviews.answer_evaluation.evaluation_type.self.description'
        ),
      }
    case 'manager':
      return {
        title: i18n.t(
          'performance_process.reviews.answer_evaluation.evaluation_type.manager.title'
        ),
        description: i18n.t(
          'performance_process.reviews.answer_evaluation.evaluation_type.manager.description'
        ),
      }
    case 'direct_reports':
      return {
        title: i18n.t(
          'performance_process.reviews.answer_evaluation.evaluation_type.direct_reports.title'
        ),
        description: i18n.t(
          'performance_process.reviews.answer_evaluation.evaluation_type.direct_reports.description'
        ),
      }
    case 'peers':
      return {
        title: i18n.t('performance_process.reviews.answer_evaluation.evaluation_type.peers.title'),
        description: i18n.t(
          'performance_process.reviews.answer_evaluation.evaluation_type.peers.description'
        ),
      }
    default:
      return {
        title: i18n.t('performance_process.reviews.answer_evaluation.evaluation_type.self.title'),
        description: i18n.t(
          'performance_process.reviews.answer_evaluation.evaluation_type.self.description'
        ),
      }
  }
}
